
  export default {
    name: 'SectionPricingTables',
    components: {
      RichText: () => import('@/components/elements/RichText'),
      PricingTableSubscriptions: () =>
        import('@/components/PricingTableSubscriptions'),
      PricingTableJobpostings: () =>
        import('@/components/PricingTableJobpostings'),
      PricingTableBoosterCampaigns: () =>
        import('@/components/PricingTableBoosterCampaigns'),
      PricingTableJobPostingContingents: () =>
        import('@/components/PricingTableJobPostingContingents'),
      PricingTablePbSearchContingents: () =>
        import('@/components/PricingTablePbSearchContingents'),
      PricingTablePbCoinContingents: () =>
        import('@/components/PricingTablePbCoinContingents'),
      CustomBigTitle: () => import('@/components/CustomBigTitle'),
    },
    props: {
      section: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    serverCacheKey: function (props) {
      return 'section-pricing-tables-' + props.section.id;
    },
  };
